import React from "react";
import { Button } from '@mantine/core';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PrintLabel from "../../components/utilities/PrintLabel";

const PrintKelengkapanPDF = ({ stateData }) => {

    const handleCreatePDF = (e, url) => {
        e.preventDefault();
        window.open(url);
    }

    return (
        <React.Fragment>
            <PDFDownloadLink
                document={
                    <PrintLabel
                        stateData={{
                            projectId: stateData.projectId,
                            kelengkapan: stateData.data.value,
                            barangNama: stateData.barangNama,
                            kerusakan: stateData.kerusakan,
                            customer: stateData.customer,
                            tanggalMasuk: stateData.tanggalMasuk,
                        }}
                    />
                }
                fileName={`label_${stateData.projectId}.pdf`}
                style={{
                    textDecoration: 'none'
                }}
            >
                {({ blob, url, loading, error }) =>
                    <Button
                        size="xs"
                        onClick={(e) => handleCreatePDF(e, url)}
                    >
                        PRINT LABEL
                    </Button>
                }
            </PDFDownloadLink>
        </React.Fragment>
    )
}

export default PrintKelengkapanPDF;